export default {
	ON_SCOPE_DESTROY: '$destroy',
	KEY_CODE_ENTER: 13,
	ARRAY_ONE_INDEX: 1,
	EMPTY_STRING: ''
};
